import $ from 'jquery';

$('.accordion__toggle').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    const $parent = $(this).closest('.accordion__element');
    const $check = $parent.find('.accordion__check');
    if ($check.prop('checked')) {
        $check.prop('checked', false);
    } else  {
        $check.prop('checked', true);
    }
})


// in case we got "radio" buttons, this piece of js allows
// unchecking of an activated radio button. Every other
// behaviour is done in CSS.
$('.accordion--radio .accordion__header').on('click', function (ev) {
    const $parent = $(this).closest('.accordion__element');
    const $check = $parent.find('.accordion__check');
    if ($check.prop('checked')) {
        $check.prop('checked', false);
        ev.preventDefault();
    }
});

$('.accordion__content-wrap').find('*').on('focus', function () {
    const $parent = $(this).closest('.accordion__element');
    $parent.find('.accordion__toggle').trigger('click');
})
